'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M704 832h-512v-512h288l128-128h-544v768h768v-544l-128 128v288z' }),
        React.createElement('path', { d: 'M1024 0h-416l160 160-480 480 96 96 480-480 160 160v-416z' })
    ));
};